import React, { useState } from 'react';
import api from '../api/api';
import { Form, Button, Card, Modal, Alert } from 'react-bootstrap';
import { useToast } from './Toasts';

function LoginForm({ onLogin, darkMode, cardBgClass }) {
  const { notify } = useToast();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [showForgotModal, setShowForgotModal] = useState(false);
  const [forgotInput, setForgotInput] = useState('');
  const [forgotMessage, setForgotMessage] = useState(null);

  const handleLogin = async () => {
    try {
      await api.post('/login', { username, password, remember_me: rememberMe });
      onLogin();
    } catch (err) {
      notify('Login fehlgeschlagen. Prüfe Benutzername und Passwort.', 'danger');
    }
  };

  const handleForgotPassword = async () => {
    setForgotMessage(null);

    const trimmed = forgotInput.trim();
    if (trimmed.length === 0) {
      setForgotMessage({ type: 'danger', text: 'Bitte Benutzername oder E-Mail eingeben.' });
      return;
    }

    const isEmail = trimmed.includes('@');

    try {
      const res = await api.post('/forgot-password', {
        ...(isEmail ? { email: trimmed } : { benutzername: trimmed })
      });

      if (res.data.status === 'passwort_gesendet') {
        setForgotMessage({ type: 'success', text: '✅ Neues Passwort wurde per E-Mail verschickt.' });
        setForgotInput(''); // Eingabefeld leeren
      } else {
        setForgotMessage({ type: 'danger', text: '❌ Fehler: ' + (res.data.error || 'Unbekannter Fehler') });
      }
    } catch (err) {
      setForgotMessage({ type: 'danger', text: '❌ Anfrage fehlgeschlagen. Bitte erneut versuchen.' });
    }
  };


  return (
    <>
      <Card className={`p-4 shadow-sm mb-5 ${cardBgClass}`}>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label className={darkMode ? 'text-light' : ''}>Benutzername:</Form.Label>
            <Form.Control
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Benutzername eingeben"
              className={darkMode ? cardBgClass : ''}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label className={darkMode ? 'text-light' : ''}>Passwort:</Form.Label>
            <Form.Control
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Passwort eingeben"
              className={darkMode ? cardBgClass : ''}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Check
              type="checkbox"
              id="rememberMe"
              label="Angemeldet bleiben (90 Tage)"
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.target.checked)}
              className={darkMode ? 'text-light' : ''}
            />
          </Form.Group>

          <div className="d-flex justify-content-between">
            <Button variant="primary" onClick={handleLogin}>
              Login
            </Button>
            <Button variant="link" onClick={() => setShowForgotModal(true)}>
              Passwort vergessen?
            </Button>
          </div>
        </Form>
      </Card>

      {/* Passwort vergessen Modal */}
      <Modal show={showForgotModal} onHide={() => setShowForgotModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>🔐 Passwort vergessen</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Benutzername oder E-Mail</Form.Label>
            <Form.Control
              type="text"
              placeholder="z. B. roony oder roony@mail.de"
              value={forgotInput}
              onChange={(e) => setForgotInput(e.target.value)}
            />
          </Form.Group>

          {forgotMessage && (
            <Alert variant={forgotMessage.type}>{forgotMessage.text}</Alert>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowForgotModal(false)}>
            Abbrechen
          </Button>
          <Button variant="primary" onClick={handleForgotPassword}>
            Passwort zurücksetzen
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default LoginForm;